export function scrollbar_width() {	
	console.log('Sidebar Width Called');		 
	/* Modified from: http://jdsharp.us/jQuery/minute/calculate-scrollbar-width.php */
	var calculation_content = $('<div style="width:50px;height:50px;overflow:hidden;position:absolute;top:-200px;left:-200px;"><div style="height:100px;"></div>');
	$('body').append( calculation_content );
	var width_one = $('div', calculation_content).innerWidth();
	calculation_content.css('overflow-y', 'scroll');
	var width_two = $('div', calculation_content).innerWidth();
	$(calculation_content).remove();
	console.log(width_one - width_two);
	return ( width_one - width_two );
}